<template>
  <div class="gsbg">
    <div class="xcx">
      <el-row :gutter="20">
        <el-col :span="8"><div class="grid-content bg-purple">
        <img src="../assets/dxtc.jpg" />
        <p>点选停车</p>
        <span>请使用微信客户端扫码查看</span>
        </div></el-col>
        <el-col :span="8"><div class="grid-content bg-purple">
        <img src="../assets/dxxq.jpg" />
        <p>点选找房</p>
         <span>请使用微信客户端扫码查看</span>
        </div></el-col>
        <el-col :span="8"><div class="grid-content bg-purple">
        <img src="../assets/dxxq.jpg" />
        <p>点选学区</p>
         <span>请使用微信客户端扫码查看</span>
        </div></el-col>
      </el-row>
      <div>
        <p style="padding-top: 100px;">苏ICP备18024043号-2</p>
      </div>
	  
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style>
  .gsbg{
    background: url(../assets/bg.png);
    background-size: auto;
    width: 100%;
    height: 950px;
  }
  .xcx{
    width: 95%;
    height: auto;
    margin: 0px auto;
    padding-top: 400px;
  }
  .gsbg p{
    color: #fff;
  }
  .gsbg span{
    color: #ccc;
        font-size: 12px;
        position: relative;
        top: -12px;
  }
  .gsbg img{
    width: 200px;
    padding-top: 10px;
  }
  .el-row {
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #00000059;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue